import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectApi, selectUserId } from '@socialive/common';

export default createAsyncThunk('portal/fetchComposerTokens', async (payload, { getState, dispatch }) => {
  const { hash } = payload;

  const api = selectApi(getState());
  const userId = selectUserId(getState());

  const [
    {
      sfu: { domain: sfu },
    },
    { appId, token: agoraToken },
    brokerToken,
  ] = await Promise.all([
    api(`/broadcast/join/${hash}`, {
      data: {},
      method: 'POST',
    }),
    api(`/auth/sfu/token/${hash}`, {
      data: { userId, streamType: 'COMPOSER' },
      method: 'POST',
    }),
    api(`/broadcast/${hash}/broker-token`, { method: 'POST' }),
  ]);

  return {
    sfu,
    brokerToken: encodeURIComponent(brokerToken),
    appId: encodeURIComponent(appId),
    agoraToken: encodeURIComponent(agoraToken),
  };
});
